import React, { useEffect, useState, Component } from 'react';
import { Truck, Clock, Package, CalendarCheck, ArrowLeft, ChevronRight, AlertTriangle, RotateCcw, Sparkles, ArrowRightLeft, Layers, MapPin, Search, Check, X, Camera, Upload, CheckCircle2 } from 'lucide-react';
import { RouteStep } from './OrderRoute';
import { TrackingEvents, TrackingEvent } from './TrackingEvents';
import { AnomalyCard } from './AnomalyCard';
import { ClientReturn, ReturnReason } from './types';
import { SpedizioneDetail as AdminSpedizioneDetail, Shipment as AdminShipment } from '../operator/Spedizioni';
const CARRIER_LOGOS: Record<string, string> = {
  BRT: 'https://cdn.magicpatterns.com/uploads/cmtJEf49a5eVZLpdSNFSih/BRT_logo_cropped.png',
  FedEx: 'https://cdn.magicpatterns.com/uploads/bJFTTvq6RiT6tx6MWd19DM/FedEx-Logo.png',
  GLS: 'https://cdn.magicpatterns.com/uploads/kLsfczSQhw6HQ17cu2iXe1/GLS_Logo_2021.svg.png',
  SDA: 'https://cdn.magicpatterns.com/uploads/uzuZLxLhuWymtodu3YDZcY/1620120317-sda-poste-logo.webp',
  UPS: 'https://cdn.magicpatterns.com/uploads/5fMcthEgdAwTbqPzFRcjsj/logo_corriere_ups_500.png'
};
type ColloType = 'Riassortimento' | 'Nuova collezione' | 'Trasferimento' | 'Stagionale';
type OrderStatus = 'In partenza' | 'In transito' | 'In consegna' | 'Consegnata' | 'Anomalia';
type OrderItem = {
  id: string;
  name: string;
  sku: string;
  quantity: number;
};
type Order = {
  id: string;
  trackingId: string;
  destination: string;
  carrier: string;
  carrierLogo: string;
  status: OrderStatus;
  eta: string;
  hasAnomaly: boolean;
  colli: number;
  colloType: ColloType;
  contentSummary: string;
  items: OrderItem[];
};
const ORDERS: Order[] = [{
  id: 'SH-2840-119',
  trackingId: 'FX4892013',
  destination: 'Galleria Vittorio Emanuele, Milano',
  carrier: 'FedEx',
  carrierLogo: CARRIER_LOGOS.FedEx,
  status: 'Anomalia',
  eta: 'Domani',
  hasAnomaly: true,
  colli: 6,
  colloType: 'Riassortimento',
  contentSummary: 'T-shirt, polo, bermuda · 42 SKU',
  items: [{
    id: 'i1',
    name: 'T-shirt logo bianca',
    sku: 'TS-LG-W-M',
    quantity: 4
  }, {
    id: 'i2',
    name: 'Polo piqué navy',
    sku: 'PO-PQ-N-L',
    quantity: 2
  }, {
    id: 'i3',
    name: 'Bermuda lino',
    sku: 'BR-LN-BE-32',
    quantity: 3
  }]
}, {
  id: 'SH-2840-118',
  trackingId: 'FX9923011',
  destination: 'Via del Corso 88, Roma',
  carrier: 'FedEx',
  carrierLogo: CARRIER_LOGOS.FedEx,
  status: 'In consegna',
  eta: 'Oggi 16:30',
  hasAnomaly: false,
  colli: 4,
  colloType: 'Nuova collezione',
  contentSummary: 'Cappotti, blazer, maglieria',
  items: [{
    id: 'i1',
    name: 'Cappotto cammello',
    sku: 'CP-CM-50',
    quantity: 1
  }, {
    id: 'i2',
    name: 'Sciarpa cashmere',
    sku: 'SC-CH-GR',
    quantity: 2
  }]
}, {
  id: 'SH-2840-117',
  trackingId: 'GLS882211',
  destination: 'Via Roma 24, Torino',
  carrier: 'GLS',
  carrierLogo: CARRIER_LOGOS.GLS,
  status: 'In transito',
  eta: '12 mag',
  hasAnomaly: false,
  colli: 5,
  colloType: 'Riassortimento',
  contentSummary: 'Sneakers, mocassini · taglie 38-44',
  items: [{
    id: 'i1',
    name: 'Sneakers basic bianche',
    sku: 'SK-WH-42',
    quantity: 2
  }, {
    id: 'i2',
    name: 'Sneakers basic nere',
    sku: 'SK-BK-43',
    quantity: 2
  }]
}, {
  id: 'SH-2840-116',
  trackingId: 'UPS771203',
  destination: 'Via Etnea 102, Catania',
  carrier: 'UPS',
  carrierLogo: CARRIER_LOGOS.UPS,
  status: 'Consegnata',
  eta: 'Consegnata 08 mag',
  hasAnomaly: false,
  colli: 3,
  colloType: 'Stagionale',
  contentSummary: 'Costumi mare e accessori',
  items: [{
    id: 'i1',
    name: 'Costume mare uomo',
    sku: 'CM-UM-M-BL',
    quantity: 4
  }, {
    id: 'i2',
    name: 'Pareo donna',
    sku: 'PA-DN-UN-FL',
    quantity: 3
  }]
}, {
  id: 'SH-2840-115',
  trackingId: 'SDA445102',
  destination: 'Via Toledo 145, Napoli',
  carrier: 'SDA',
  carrierLogo: CARRIER_LOGOS.SDA,
  status: 'In partenza',
  eta: '14 mag',
  hasAnomaly: false,
  colli: 7,
  colloType: 'Trasferimento',
  contentSummary: 'Stock invenduto AI25',
  items: [{
    id: 'i1',
    name: 'Borsa media pelle',
    sku: 'BR-PL-MD-CG',
    quantity: 1
  }, {
    id: 'i2',
    name: 'Cintura uomo',
    sku: 'CN-UM-S-NR',
    quantity: 2
  }]
}];
const COLLO_TYPE_ICON: Record<ColloType, ComponentType<any>> = {
  Riassortimento: RotateCcw,
  'Nuova collezione': Sparkles,
  Trasferimento: ArrowRightLeft,
  Stagionale: Layers
};
const STATUS_BADGE: Record<OrderStatus, string> = {
  'In partenza': 'bg-[#0A0A0A] border-[#262626] text-[#9A9A9A]',
  'In transito': 'bg-[#5DA9FF]/10 border-[#5DA9FF]/30 text-[#5DA9FF]',
  'In consegna': 'bg-[#D4FF3A]/10 border-[#D4FF3A]/30 text-[#D4FF3A]',
  Consegnata: 'bg-[#0A0A0A] border-[#262626] text-[#9A9A9A]',
  Anomalia: 'bg-[#EF4444]/10 border-[#EF4444]/30 text-[#EF4444]'
};
type OrderDetail = {
  id: string;
  steps: RouteStep[];
  events: TrackingEvent[];
  origin: string;
  destinationCity: string;
  progress: number;
  anomaly?: {
    issue: string;
    fieldLabel: string;
    initialValue: string;
  };
};
const ORDER_DETAILS: Record<string, OrderDetail> = {
  'SH-2840-119': {
    id: 'SH-2840-119',
    origin: 'Roma',
    destinationCity: 'Milano',
    progress: 0.45,
    steps: [{
      label: 'Preso in carico',
      location: 'Magazzino Roma',
      timestamp: '09 mag, 08:12',
      status: 'completed'
    }, {
      label: 'Hub smistamento',
      location: 'Bologna',
      timestamp: '09 mag, 21:45',
      status: 'completed'
    }, {
      label: 'In transito',
      location: 'Hub Milano',
      timestamp: '10 mag, 06:20',
      status: 'current'
    }, {
      label: 'In consegna',
      location: 'Milano centro',
      status: 'pending'
    }, {
      label: 'Consegnato',
      location: 'Negozio',
      status: 'pending'
    }],
    events: [{
      date: '10 mag',
      timestamp: '07:42',
      location: 'Hub Milano',
      description: 'Anomalia rilevata: orario di consegna fuori dalle aperture del negozio',
      type: 'warning'
    }, {
      date: '10 mag',
      timestamp: '06:20',
      location: 'Hub Milano',
      description: "Spedizione arrivata all'hub di destinazione",
      type: 'info'
    }, {
      date: '09 mag',
      timestamp: '21:45',
      location: 'Bologna',
      description: 'In transito hub Bologna',
      type: 'info'
    }, {
      date: '09 mag',
      timestamp: '08:12',
      location: 'Magazzino Roma',
      description: 'Spedizione partita dal magazzino centrale',
      type: 'pickup'
    }],
    anomaly: {
      issue: 'Il vettore vuole consegnare alle 13:30, ma il negozio è chiuso per la pausa pranzo (13:00–15:30). Inserisci la fascia oraria di ricezione del negozio per riprogrammare la consegna.',
      fieldLabel: 'Fascia oraria di ricezione',
      initialValue: '09:30 – 13:00 / 15:30 – 19:30'
    }
  },
  'SH-2840-118': {
    id: 'SH-2840-118',
    origin: 'Roma',
    destinationCity: 'Roma',
    progress: 0.85,
    steps: [{
      label: 'Preso in carico',
      location: 'Magazzino Roma',
      timestamp: '08 mag, 14:02',
      status: 'completed'
    }, {
      label: 'Hub smistamento',
      location: 'Bologna',
      timestamp: '09 mag, 02:18',
      status: 'completed'
    }, {
      label: 'In transito',
      location: 'Hub Roma',
      timestamp: '10 mag, 05:40',
      status: 'completed'
    }, {
      label: 'In consegna',
      location: 'Roma centro',
      timestamp: '10 mag, 12:10',
      status: 'current'
    }, {
      label: 'Consegnato',
      location: 'Negozio',
      status: 'pending'
    }],
    events: [{
      date: '10 mag',
      timestamp: '12:10',
      location: 'Roma',
      description: 'Spedizione affidata al corriere per la consegna al negozio',
      type: 'info'
    }, {
      date: '10 mag',
      timestamp: '05:40',
      location: 'Hub Roma',
      description: 'In transito hub Roma',
      type: 'info'
    }, {
      date: '09 mag',
      timestamp: '02:18',
      location: 'Bologna',
      description: 'Smistamento hub Bologna',
      type: 'info'
    }, {
      date: '08 mag',
      timestamp: '14:02',
      location: 'Magazzino Roma',
      description: 'Spedizione partita dal magazzino centrale',
      type: 'pickup'
    }]
  },
  'SH-2840-117': {
    id: 'SH-2840-117',
    origin: 'Roma',
    destinationCity: 'Torino',
    progress: 0.3,
    steps: [{
      label: 'Preso in carico',
      location: 'Magazzino Roma',
      timestamp: '09 mag, 17:30',
      status: 'completed'
    }, {
      label: 'Hub smistamento',
      location: 'Milano',
      timestamp: '10 mag, 03:10',
      status: 'current'
    }, {
      label: 'In transito',
      location: 'Torino',
      status: 'pending'
    }, {
      label: 'In consegna',
      location: 'Torino centro',
      status: 'pending'
    }, {
      label: 'Consegnato',
      location: 'Negozio',
      status: 'pending'
    }],
    events: [{
      date: '10 mag',
      timestamp: '03:10',
      location: 'Hub Milano',
      description: 'In smistamento presso hub Milano',
      type: 'info'
    }, {
      date: '09 mag',
      timestamp: '17:30',
      location: 'Magazzino Roma',
      description: 'Spedizione partita dal magazzino centrale',
      type: 'pickup'
    }]
  },
  'SH-2840-116': {
    id: 'SH-2840-116',
    origin: 'Roma',
    destinationCity: 'Catania',
    progress: 1.0,
    steps: [{
      label: 'Preso in carico',
      location: 'Magazzino Roma',
      timestamp: '08 mag, 10:22',
      status: 'completed'
    }, {
      label: 'Hub smistamento',
      location: 'Bologna',
      timestamp: '08 mag, 23:00',
      status: 'completed'
    }, {
      label: 'In transito',
      location: 'Hub Napoli',
      timestamp: '10 mag, 04:15',
      status: 'completed'
    }, {
      label: 'In consegna',
      location: 'Catania',
      timestamp: '10 mag, 09:30',
      status: 'completed'
    }, {
      label: 'Consegnato',
      location: 'Negozio',
      timestamp: '10 mag, 14:20',
      status: 'completed'
    }],
    events: [{
      date: '10 mag',
      timestamp: '14:20',
      location: 'Catania',
      description: 'Consegna effettuata con successo',
      type: 'info'
    }, {
      date: '10 mag',
      timestamp: '09:30',
      location: 'Catania',
      description: 'In consegna',
      type: 'info'
    }]
  },
  'SH-2840-115': {
    id: 'SH-2840-115',
    origin: 'Roma',
    destinationCity: 'Napoli',
    progress: 0.1,
    steps: [{
      label: 'Preso in carico',
      location: 'Magazzino Roma',
      timestamp: '10 mag, 06:00',
      status: 'current'
    }, {
      label: 'Hub smistamento',
      location: 'Bologna',
      status: 'pending'
    }, {
      label: 'In transito',
      location: 'Hub Napoli',
      status: 'pending'
    }, {
      label: 'In consegna',
      location: 'Napoli centro',
      status: 'pending'
    }, {
      label: 'Consegnato',
      location: 'Negozio',
      status: 'pending'
    }],
    events: [{
      date: '10 mag',
      timestamp: '06:00',
      location: 'Magazzino Roma',
      description: 'Spedizione partita dal magazzino centrale',
      type: 'pickup'
    }]
  }
};
type Props = {
  returns: ClientReturn[];
  onAddReturn: (r: ClientReturn) => void;
  initialSelectedId?: string | null;
};
export function ClientSpedizioni({
  returns,
  onAddReturn,
  initialSelectedId
}: Props) {
  const [selectedId, setSelectedId] = useState<string | null>(initialSelectedId ?? null);
  useEffect(() => {
    if (initialSelectedId) setSelectedId(initialSelectedId);
  }, [initialSelectedId]);
  const [filter, setFilter] = useState<'Tutte' | 'In transito' | 'Consegnate' | 'Anomalie'>('Tutte');
  const [query, setQuery] = useState('');
  const selected = ORDERS.find(o => o.id === selectedId) || null;
  const detail = selected ? ORDER_DETAILS[selected.id] : null;
  if (selected && detail) {
    const existingReturn = returns.find(r => r.shipmentId === selected.id);
    return <SpedizioneDetail order={selected} detail={detail} existingReturn={existingReturn} onBack={() => setSelectedId(null)} onAddReturn={onAddReturn} data-id="element-285" />;
  }
  const filtered = ORDERS.filter(o => {
    if (filter === 'In transito' && o.status !== 'In transito' && o.status !== 'In consegna' && o.status !== 'In partenza') return false;
    if (filter === 'Consegnate' && o.status !== 'Consegnata') return false;
    if (filter === 'Anomalie' && !o.hasAnomaly) return false;
    const q = query.trim().toLowerCase();
    if (!q) return true;
    return `${o.id} ${o.trackingId} ${o.destination} ${o.contentSummary}`.toLowerCase().includes(q);
  });
  return <div className="space-y-6" data-id="element-286">
      <div className="flex items-end justify-between flex-wrap gap-3" data-id="element-287">
        <div data-id="element-288">
          <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-289">
            Spedizioni
          </h1>
        </div>
      </div>

      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-290">
        {/* Filter / search header */}
        <div className="p-4 sm:p-5 flex items-center gap-3 flex-wrap border-b border-[#1F1F1F]" data-id="element-291">
          <div className="flex items-center gap-1 p-1 rounded-lg bg-[#0A0A0A] border border-[#1F1F1F] overflow-x-auto" data-id="element-292">
            {(['Tutte', 'In transito', 'Consegnate', 'Anomalie'] as const).map(f => <button key={f} onClick={() => setFilter(f)} className={`px-2.5 py-1 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${filter === f ? 'bg-[#1F1F1F] text-[#FAFAFA]' : 'text-[#9A9A9A] hover:text-[#FAFAFA]'}`} data-id="element-293">
                  {f}
                </button>)}
          </div>
          <div className="relative ml-auto w-full sm:w-auto" data-id="element-294">
            <Search className="h-4 w-4 text-[#6B6B6B] absolute left-3 top-1/2 -translate-y-1/2" data-id="element-295" />
            <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Cerca per ID, tracking, destinazione..." className="w-full sm:w-72 pl-9 pr-3 py-1.5 rounded-lg bg-[#0A0A0A] border border-[#1F1F1F] text-xs text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/30" data-id="element-296" />
          </div>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden divide-y divide-[#1F1F1F]" data-id="element-297">
          {filtered.map(o => {
          const Icon = COLLO_TYPE_ICON[o.colloType];
          return <button key={o.id} type="button" onClick={() => setSelectedId(o.id)} className="w-full text-left p-4 hover:bg-[#0A0A0A] transition" data-id="element-298">
                <div className="flex items-start gap-3" data-id="element-299">
                  <div className="h-9 w-10 rounded bg-white flex items-center justify-center shrink-0 p-1" data-id="element-300">
                    <img src={o.carrierLogo} alt={o.carrier} className="max-w-full max-h-full object-contain" data-id="element-301" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-302">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-303">
                      <span className="text-sm font-mono text-[#FAFAFA]" data-id="element-304">
                        {o.id}
                      </span>
                      <StatusBadge order={o} data-id="element-305" />
                    </div>
                    <div className="text-[11px] text-[#6B6B6B] font-mono mt-0.5" data-id="element-306">
                      {o.trackingId}
                    </div>
                    <div className="text-xs text-[#9A9A9A] mt-1 flex items-center gap-1" data-id="element-307">
                      <MapPin className="h-3 w-3 text-[#6B6B6B]" data-id="element-308" />
                      <span className="truncate" data-id="element-309">{o.destination}</span>
                    </div>
                    <div className="flex items-center gap-3 mt-2 text-[11px] text-[#9A9A9A] flex-wrap" data-id="element-310">
                      <span className="inline-flex items-center gap-1" data-id="element-311">
                        <Icon className="h-3 w-3 text-[#6B6B6B]" data-id="element-312" />
                        {o.colloType}
                      </span>
                      <span data-id="element-313">{o.colli} colli</span>
                      <span className="inline-flex items-center gap-1 text-[#D4FF3A]" data-id="element-314">
                        <CalendarCheck className="h-3 w-3" data-id="element-315" />
                        {o.eta}
                      </span>
                    </div>
                  </div>
                  <ChevronRight className="h-4 w-4 text-[#6B6B6B] shrink-0 mt-1" data-id="element-316" />
                </div>
              </button>;
        })}
          {filtered.length === 0 && <div className="p-10 text-center text-sm text-[#6B6B6B]" data-id="element-317">
              Nessuna spedizione corrisponde ai filtri.
            </div>}
        </div>

        {/* Desktop table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-318">
          <table className="w-full text-sm [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap" data-id="element-319">
            <thead data-id="element-320">
              <tr className="text-left text-[10px] uppercase tracking-wider text-[#6B6B6B] border-b border-[#1F1F1F]" data-id="element-321">
                <th className="px-5 py-3 font-medium" data-id="element-322">Spedizione</th>
                <th className="px-5 py-3 font-medium" data-id="element-323">Corriere</th>
                <th className="px-5 py-3 font-medium" data-id="element-324">Destinazione</th>
                <th className="px-5 py-3 font-medium" data-id="element-325">Tipo collo</th>
                <th className="px-5 py-3 font-medium text-center" data-id="element-326">Colli</th>
                <th className="px-5 py-3 font-medium" data-id="element-327">Contenuto</th>
                <th className="px-5 py-3 font-medium" data-id="element-328">Stato</th>
                <th className="px-5 py-3 font-medium" data-id="element-329">Consegna prevista</th>
                <th className="px-5 py-3 font-medium w-8" data-id="element-330" />
              </tr>
            </thead>
            <tbody data-id="element-331">
              {filtered.map(o => {
              const Icon = COLLO_TYPE_ICON[o.colloType];
              return <tr key={o.id} onClick={() => setSelectedId(o.id)} className="border-b border-[#1F1F1F] last:border-0 hover:bg-[#0A0A0A] transition-colors cursor-pointer" data-id="element-332">
                    <td className="px-5 py-3.5" data-id="element-333">
                      <div className="min-w-0" data-id="element-334">
                        <div className="text-sm font-mono text-[#FAFAFA]" data-id="element-335">
                          {o.id}
                        </div>
                        <div className="text-[10px] font-mono text-[#6B6B6B] mt-0.5" data-id="element-336">
                          {o.trackingId}
                        </div>
                      </div>
                    </td>
                    <td className="px-5 py-3.5" data-id="element-337">
                      <div className="flex items-center gap-2" data-id="element-338">
                        <div className="h-6 w-8 rounded bg-white flex items-center justify-center p-0.5" data-id="element-339">
                          <img src={o.carrierLogo} alt={o.carrier} className="max-w-full max-h-full object-contain" data-id="element-340" />
                        </div>
                        <span className="text-xs text-[#9A9A9A]" data-id="element-341">
                          {o.carrier}
                        </span>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-[#9A9A9A] max-w-[220px] truncate" data-id="element-342">
                      {o.destination}
                    </td>
                    <td className="px-5 py-3.5" data-id="element-343">
                      <span className="inline-flex items-center gap-1.5 px-1.5 py-0.5 rounded text-[11px] bg-[#0A0A0A] border border-[#262626] text-[#9A9A9A]" data-id="element-344">
                        <Icon className="h-3 w-3" data-id="element-345" />
                        {o.colloType}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-center font-mono text-sm text-[#FAFAFA]" data-id="element-346">
                      {o.colli}
                    </td>
                    <td className="px-5 py-3.5 text-[#9A9A9A] max-w-[220px] truncate text-xs" data-id="element-347">
                      {o.contentSummary}
                    </td>
                    <td className="px-5 py-3.5" data-id="element-348">
                      <StatusBadge order={o} data-id="element-349" />
                    </td>
                    <td className="px-5 py-3.5" data-id="element-350">
                      <div className="inline-flex items-center gap-1.5 text-xs" data-id="element-351">
                        <CalendarCheck className="h-3 w-3 text-[#D4FF3A]" data-id="element-352" />
                        <span className="font-mono text-[#FAFAFA]" data-id="element-353">
                          {o.eta}
                        </span>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-right" data-id="element-354">
                      <ChevronRight className="h-4 w-4 text-[#6B6B6B] inline" data-id="element-355" />
                    </td>
                  </tr>;
            })}
              {filtered.length === 0 && <tr data-id="element-356">
                  <td colSpan={9} className="px-5 py-12 text-center text-sm text-[#6B6B6B]" data-id="element-357">
                    Nessuna spedizione corrisponde ai filtri.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}
function StatusBadge({
  order
}: {
  order: Order;
}) {
  return <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold border ${STATUS_BADGE[order.status]}`} data-id="element-358">
      {order.hasAnomaly && <AlertTriangle className="h-3 w-3 mr-0.5" data-id="element-359" />}
      {order.status}
    </span>;
}
function SpedizioneDetail({
  order,
  detail,
  existingReturn,
  onBack,
  onAddReturn
}: {
  order: Order;
  detail: OrderDetail;
  existingReturn?: ClientReturn;
  onBack: () => void;
  onAddReturn: (r: ClientReturn) => void;
}) {
  const [returnFormOpen, setReturnFormOpen] = useState(false);
  const Icon = COLLO_TYPE_ICON[order.colloType];
  const canRequestReturn = order.status === 'Consegnata' && !existingReturn;
  const parts = order.destination.split(',').map(s => s.trim());
  const adminShipment: AdminShipment = {
    id: order.id,
    reference: order.id,
    store: parts[1] || order.destination,
    address: parts[0] || order.destination,
    city: parts[1] || '',
    carrier: order.carrier,
    trackingId: order.trackingId,
    status: order.status as any,
    cost: '—',
    departure: detail.steps[0]?.timestamp || '—',
    eta: order.eta,
    weight: '—',
    colli: order.colli,
    signed: order.status === 'Consegnata' ? 'ok' : 'none',
    contact: {
      name: '—',
      phone: '—',
      email: '—'
    },
    steps: detail.steps as any,
    events: detail.events as any
  } as any;
  const infoGrid = <InfoGridContent order={order} Icon={Icon} data-id="element-360" />;
  const returnBanner = existingReturn ? <div className="bg-[#F5A524]/10 border border-[#F5A524]/30 rounded-xl p-4 flex items-start gap-3" data-id="element-361">
      <RotateCcw className="h-4 w-4 text-[#F5A524] shrink-0 mt-0.5" data-id="element-362" />
      <div className="flex-1 min-w-0" data-id="element-363">
        <div className="text-sm font-semibold text-[#FAFAFA]" data-id="element-364">
          Richiesta di reso aperta
        </div>
        <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-365">
          {existingReturn.id} · {existingReturn.reason} ·{' '}
          <span className="text-[#F5A524] font-medium" data-id="element-366">
            {existingReturn.status}
          </span>
        </div>
      </div>
    </div> : null;
  const banner = returnBanner ? <div className="space-y-3" data-id="element-367">{returnBanner}</div> : null;
  const extra = <>
      <div className="bg-[#181818] border border-[#262626] rounded-xl p-5" data-id="element-368">
        <div className="flex items-start justify-between gap-4 flex-wrap" data-id="element-369">
          <div className="min-w-0 flex-1" data-id="element-370">
            <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-371">
              Hai riscontrato un problema?
            </h3>
            <p className="text-xs text-[#9A9A9A] mt-1 max-w-md" data-id="element-372">
              {order.status === 'Consegnata' ? 'Se i capi sono difettosi, errati o danneggiati puoi aprire una richiesta di reso. Ti risponderemo entro 48 ore lavorative.' : 'Potrai aprire una richiesta di reso solo dopo che la spedizione sarà stata consegnata.'}
            </p>
          </div>
          <button type="button" disabled={!canRequestReturn} onClick={() => setReturnFormOpen(true)} className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold transition shrink-0 ${canRequestReturn ? 'bg-[#D4FF3A] text-[#0A0A0A] hover:bg-[#c2ed28]' : 'bg-[#1F1F1F] text-[#6B6B6B] cursor-not-allowed'}`} data-id="element-373">
            <RotateCcw className="h-4 w-4" data-id="element-374" />
            {existingReturn ? 'Reso già aperto' : 'Apri richiesta di reso'}
          </button>
        </div>
      </div>
      {returnFormOpen && <ReturnFormDrawer order={order} onClose={() => setReturnFormOpen(false)} onSubmit={payload => {
      onAddReturn(payload);
      setReturnFormOpen(false);
    }} data-id="element-375" />}
    </>;
  return <AdminSpedizioneDetail shipment={adminShipment} onBack={onBack} banner={banner} infoGrid={infoGrid} extra={extra} data-id="element-376" />;
  return <div className="space-y-6" data-id="element-377">
      <button type="button" onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-[#9A9A9A] hover:text-[#FAFAFA] transition" data-id="element-378">
        <ArrowLeft className="h-4 w-4" data-id="element-379" />
        Torna alle spedizioni
      </button>

      {/* Header */}
      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-380">
        <div className="p-4 sm:p-5 flex items-start justify-between gap-6 flex-wrap" data-id="element-381">
          <div className="flex items-center gap-4 min-w-0" data-id="element-382">
            <div className="h-14 w-16 rounded-lg bg-white flex items-center justify-center shrink-0 p-2" data-id="element-383">
              <img src={order.carrierLogo} alt={order.carrier} className="max-w-full max-h-full object-contain" data-id="element-384" />
            </div>
            <div className="min-w-0" data-id="element-385">
              <div className="flex items-center gap-2 mb-1" data-id="element-386">
                <Package className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-387" />
                <span className="text-xs font-mono text-[#9A9A9A] truncate" data-id="element-388">
                  Tracking {order.trackingId}
                </span>
              </div>
              <div className="text-xl font-semibold text-[#FAFAFA] font-heading font-mono" data-id="element-389">
                {order.id}
              </div>
              <div className="text-sm text-[#9A9A9A] mt-0.5 flex items-center gap-1.5" data-id="element-390">
                <MapPin className="h-3.5 w-3.5 shrink-0" data-id="element-391" />
                <span className="truncate" data-id="element-392">{order.destination}</span>
              </div>
              <div className="flex items-center gap-3 mt-2 text-xs text-[#9A9A9A] flex-wrap" data-id="element-393">
                <span className="inline-flex items-center gap-1.5" data-id="element-394">
                  <Icon className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-395" />
                  {order.colloType}
                </span>
                <span data-id="element-396">· {order.colli} colli</span>
                <span className="truncate max-w-[260px]" data-id="element-397">
                  · {order.contentSummary}
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-stretch gap-5 sm:gap-8 shrink-0" data-id="element-398">
            <div data-id="element-399">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-400">
                Stato
              </div>
              <div className="mt-1.5" data-id="element-401">
                <StatusBadge order={order} data-id="element-402" />
              </div>
            </div>
            <div className="border-l border-[#262626] pl-5 sm:pl-8" data-id="element-403">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium flex items-center gap-1" data-id="element-404">
                <CalendarCheck className="h-3 w-3" data-id="element-405" />
                Consegna prevista
              </div>
              <div className="text-sm font-mono font-semibold text-[#FAFAFA] mt-1.5" data-id="element-406">
                {order.eta}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Existing return banner */}
      {existingReturn && <div className="bg-[#F5A524]/10 border border-[#F5A524]/30 rounded-xl p-4 flex items-start gap-3" data-id="element-407">
          <RotateCcw className="h-4 w-4 text-[#F5A524] shrink-0 mt-0.5" data-id="element-408" />
          <div className="flex-1 min-w-0" data-id="element-409">
            <div className="text-sm font-semibold text-[#FAFAFA]" data-id="element-410">
              Richiesta di reso aperta
            </div>
            <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-411">
              {existingReturn.id} · {existingReturn.reason} ·{' '}
              <span className="text-[#F5A524] font-medium" data-id="element-412">
                {existingReturn.status}
              </span>
            </div>
          </div>
        </div>}

      {/* Anomaly */}
      {detail.anomaly && <AnomalyCard issue={detail.anomaly.issue} fieldLabel={detail.anomaly.fieldLabel} initialValue={detail.anomaly.initialValue} data-id="element-413" />}

      {/* Two-column: items + tracking */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-414">
        {/* Items */}
        <div className="bg-[#181818] border border-[#262626] rounded-xl" data-id="element-415">
          <div className="px-5 py-4 border-b border-[#262626] flex items-center justify-between" data-id="element-416">
            <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-417">
              Contenuto spedizione
            </h3>
            <span className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-418">
              {order.items.reduce((s, i) => s + i.quantity, 0)} capi ·{' '}
              {order.items.length} SKU
            </span>
          </div>
          <ul className="divide-y divide-[#262626]" data-id="element-419">
            {order.items.map(item => <li key={item.id} className="px-5 py-3 flex items-center justify-between gap-3" data-id="element-420">
                <div className="min-w-0" data-id="element-421">
                  <div className="text-sm text-[#FAFAFA] truncate" data-id="element-422">
                    {item.name}
                  </div>
                  <div className="text-[11px] font-mono text-[#6B6B6B] mt-0.5" data-id="element-423">
                    {item.sku}
                  </div>
                </div>
                <span className="text-sm font-mono text-[#FAFAFA] shrink-0" data-id="element-424">
                  ×{item.quantity}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Tracking timeline */}
        <div className="bg-[#181818] border border-[#262626] rounded-xl" data-id="element-425">
          <div className="px-5 py-4 border-b border-[#262626] flex items-center justify-between" data-id="element-426">
            <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-427">
              Percorso
            </h3>
            <Truck className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-428" />
          </div>
          <ol className="p-5 space-y-3 relative" data-id="element-429">
            {detail.steps.map((step, i) => {
            const isLast = i === detail.steps.length - 1;
            const isCompleted = step.status === 'completed';
            const isCurrent = step.status === 'current';
            return <li key={i} className="relative flex items-start gap-3" data-id="element-430">
                  {!isLast && <span className={`absolute left-[7px] top-4 bottom-[-12px] w-px ${isCompleted ? 'bg-[#D4FF3A]/40' : 'bg-[#262626]'}`} aria-hidden data-id="element-431" />}
                  <span className={`relative z-10 mt-1 h-3.5 w-3.5 rounded-full border-2 shrink-0 flex items-center justify-center ${isCompleted ? 'bg-[#D4FF3A] border-[#D4FF3A]' : isCurrent ? 'bg-[#181818] border-[#D4FF3A]' : 'bg-[#181818] border-[#333]'}`} data-id="element-432">
                    {isCompleted && <Check className="h-2 w-2 text-[#0A0A0A]" data-id="element-433" />}
                    {isCurrent && <span className="h-1.5 w-1.5 rounded-full bg-[#D4FF3A]" data-id="element-434" />}
                  </span>
                  <div className="min-w-0 flex-1" data-id="element-435">
                    <div className={`text-sm ${isCompleted || isCurrent ? 'text-[#FAFAFA]' : 'text-[#6B6B6B]'}`} data-id="element-436">
                      {step.label}
                    </div>
                    {step.timestamp && <div className="text-[11px] font-mono text-[#9A9A9A] mt-0.5" data-id="element-437">
                        {step.timestamp}
                      </div>}
                  </div>
                </li>;
          })}
          </ol>
        </div>
      </div>

      {/* Tracking events */}
      <TrackingEvents events={detail.events} data-id="element-438" />

      {/* Action area */}
      <div className="bg-[#181818] border border-[#262626] rounded-xl p-5" data-id="element-439">
        <div className="flex items-start justify-between gap-4 flex-wrap" data-id="element-440">
          <div className="min-w-0 flex-1" data-id="element-441">
            <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-442">
              Hai riscontrato un problema?
            </h3>
            <p className="text-xs text-[#9A9A9A] mt-1 max-w-md" data-id="element-443">
              {order.status === 'Consegnata' ? 'Se i capi sono difettosi, errati o danneggiati puoi aprire una richiesta di reso. Ti risponderemo entro 48 ore lavorative.' : 'Potrai aprire una richiesta di reso solo dopo che la spedizione sarà stata consegnata.'}
            </p>
          </div>
          <button type="button" disabled={!canRequestReturn} onClick={() => setReturnFormOpen(true)} className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold transition shrink-0 ${canRequestReturn ? 'bg-[#D4FF3A] text-[#0A0A0A] hover:bg-[#c2ed28]' : 'bg-[#1F1F1F] text-[#6B6B6B] cursor-not-allowed'}`} data-id="element-444">
            <RotateCcw className="h-4 w-4" data-id="element-445" />
            {existingReturn ? 'Reso già aperto' : 'Apri richiesta di reso'}
          </button>
        </div>
      </div>

      {returnFormOpen && <ReturnFormDrawer order={order} onClose={() => setReturnFormOpen(false)} onSubmit={payload => {
      onAddReturn(payload);
      setReturnFormOpen(false);
    }} data-id="element-446" />}
    </div>;
}
// ────────────────────────────────────────────────────────────
// Return form drawer
// ────────────────────────────────────────────────────────────
const REASONS: ReturnReason[] = ['Difettoso / danneggiato', 'Capo errato', 'Taglia o colore sbagliato', 'Non corrisponde alla descrizione', 'Danneggiato in transito', 'Altro'];
function ReturnFormDrawer({
  order,
  onClose,
  onSubmit
}: {
  order: Order;
  onClose: () => void;
  onSubmit: (payload: ClientReturn) => void;
}) {
  const [selectedItems, setSelectedItems] = useState<Record<string, boolean>>({});
  const [reason, setReason] = useState<ReturnReason | ''>('');
  const [description, setDescription] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const selectedCount = Object.values(selectedItems).filter(Boolean).length;
  const canSubmit = !!reason && selectedCount > 0;
  const handleSubmit = () => {
    if (!canSubmit) return;
    const payload: ClientReturn = {
      id: `RT-${Math.floor(10000 + Math.random() * 90000)}`,
      shipmentId: order.id,
      createdAt: new Date().toISOString().slice(0, 10),
      reason: reason as ReturnReason,
      description,
      items: order.items.filter(i => selectedItems[i.id]).map(i => ({
        id: i.id,
        name: i.name,
        sku: i.sku
      })),
      status: 'In attesa'
    };
    onSubmit(payload);
    setSubmitted(true);
  };
  return <div className="fixed inset-0 z-50 flex items-stretch justify-end" data-id="element-447">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-448" />
      <div className="relative w-full sm:max-w-lg bg-[#0A0A0A] border-l border-[#262626] flex flex-col" data-id="element-449">
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-[#262626]" data-id="element-450">
          <div className="min-w-0" data-id="element-451">
            <h3 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-452">
              {submitted ? 'Richiesta inviata' : 'Richiesta di reso'}
            </h3>
            <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-453">
              Spedizione{' '}
              <span className="font-mono text-[#FAFAFA]" data-id="element-454">{order.id}</span>
            </div>
          </div>
          <button type="button" onClick={onClose} className="p-1 rounded text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#181818] transition" aria-label="Chiudi" data-id="element-455">
            <X className="h-4 w-4" data-id="element-456" />
          </button>
        </div>

        {submitted ? <div className="flex-1 p-6 flex flex-col items-center justify-center text-center" data-id="element-457">
            <div className="h-16 w-16 rounded-full bg-[#D4FF3A]/10 border border-[#D4FF3A]/30 flex items-center justify-center mb-4" data-id="element-458">
              <CheckCircle2 className="h-8 w-8 text-[#D4FF3A]" data-id="element-459" />
            </div>
            <h4 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-460">
              Richiesta inviata
            </h4>
            <p className="text-sm text-[#9A9A9A] mt-1 max-w-xs" data-id="element-461">
              Riceverai una conferma via email entro 48 ore lavorative. Puoi
              seguire lo stato del reso nella sezione Resi.
            </p>
            <button type="button" onClick={onClose} className="mt-6 px-4 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-462">
              Chiudi
            </button>
          </div> : <>
            <div className="flex-1 overflow-y-auto p-5 space-y-5" data-id="element-463">
              {/* Items selection */}
              <div data-id="element-464">
                <div className="text-[11px] uppercase tracking-wider text-[#9A9A9A] font-medium mb-2" data-id="element-465">
                  Capi da rendere
                </div>
                <ul className="space-y-2" data-id="element-466">
                  {order.items.map(item => {
                const checked = !!selectedItems[item.id];
                return <li key={item.id} data-id="element-467">
                        <label className={`flex items-center justify-between gap-3 p-3 rounded-lg border cursor-pointer transition ${checked ? 'bg-[#D4FF3A]/5 border-[#D4FF3A]/40' : 'bg-[#181818] border-[#262626] hover:border-[#333]'}`} data-id="element-468">
                          <div className="flex items-center gap-3 min-w-0" data-id="element-469">
                            <span className={`h-4 w-4 rounded border flex items-center justify-center shrink-0 ${checked ? 'bg-[#D4FF3A] border-[#D4FF3A]' : 'bg-[#0A0A0A] border-[#333]'}`} data-id="element-470">
                              {checked && <Check className="h-3 w-3 text-[#0A0A0A]" data-id="element-471" />}
                            </span>
                            <div className="min-w-0" data-id="element-472">
                              <div className="text-sm text-[#FAFAFA] truncate" data-id="element-473">
                                {item.name}
                              </div>
                              <div className="text-[11px] font-mono text-[#6B6B6B]" data-id="element-474">
                                {item.sku} · ×{item.quantity}
                              </div>
                            </div>
                          </div>
                          <input type="checkbox" className="sr-only" checked={checked} onChange={e => setSelectedItems(s => ({
                      ...s,
                      [item.id]: e.target.checked
                    }))} data-id="element-475" />
                        </label>
                      </li>;
              })}
                </ul>
              </div>

              {/* Reason */}
              <div data-id="element-476">
                <div className="text-[11px] uppercase tracking-wider text-[#9A9A9A] font-medium mb-2" data-id="element-477">
                  Motivo del reso
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-478">
                  {REASONS.map(r => {
                const active = reason === r;
                return <button key={r} type="button" onClick={() => setReason(r)} className={`text-left px-3 py-2 rounded-lg border text-xs transition ${active ? 'bg-[#D4FF3A]/5 border-[#D4FF3A]/40 text-[#FAFAFA]' : 'bg-[#181818] border-[#262626] text-[#9A9A9A] hover:border-[#333]'}`} data-id="element-479">
                        {r}
                      </button>;
              })}
                </div>
              </div>

              {/* Description */}
              <div data-id="element-480">
                <div className="text-[11px] uppercase tracking-wider text-[#9A9A9A] font-medium mb-2" data-id="element-481">
                  Descrizione del problema
                </div>
                <textarea value={description} onChange={e => setDescription(e.target.value)} rows={4} placeholder="Descrivi cosa non va con i capi (es. cuciture difettose, taglia errata, danni sulla confezione...)" className="w-full bg-[#181818] border border-[#262626] rounded-lg px-3 py-2 text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:border-[#D4FF3A]/40 resize-none" data-id="element-482" />
              </div>

              {/* Photos */}
              <div data-id="element-483">
                <div className="text-[11px] uppercase tracking-wider text-[#9A9A9A] font-medium mb-2" data-id="element-484">
                  Foto (facoltativo)
                </div>
                <div className="grid grid-cols-3 gap-2" data-id="element-485">
                  {[0, 1, 2].map(i => <button key={i} type="button" className="aspect-square rounded-lg bg-[#181818] border border-dashed border-[#262626] hover:border-[#D4FF3A]/40 flex flex-col items-center justify-center gap-1 text-[#6B6B6B] hover:text-[#9A9A9A] transition" data-id="element-486">
                      {i === 0 ? <Camera className="h-4 w-4" data-id="element-487" /> : <Upload className="h-4 w-4" data-id="element-488" />}
                      <span className="text-[10px]" data-id="element-489">Aggiungi</span>
                    </button>)}
                </div>
              </div>

              {/* Info card */}
              <div className="bg-[#181818] border border-[#262626] rounded-lg p-3 flex items-start gap-2.5" data-id="element-490">
                <AlertTriangle className="h-4 w-4 text-[#F5A524] shrink-0 mt-0.5" data-id="element-491" />
                <div className="text-[11px] text-[#9A9A9A] leading-relaxed" data-id="element-492">
                  La richiesta verrà presa in carico entro 48 ore lavorative.
                  Conserva i capi nella confezione originale fino alla conferma.
                </div>
              </div>
            </div>

            <div className="border-t border-[#262626] px-5 py-3 flex items-center justify-between gap-2" data-id="element-493">
              <div className="text-xs text-[#9A9A9A]" data-id="element-494">
                {selectedCount > 0 ? `${selectedCount} ${selectedCount === 1 ? 'capo selezionato' : 'capi selezionati'}` : 'Seleziona almeno un capo'}
              </div>
              <div className="flex items-center gap-2" data-id="element-495">
                <button type="button" onClick={onClose} className="px-3.5 py-2 rounded-lg bg-[#181818] border border-[#262626] text-[#FAFAFA] text-sm font-medium hover:border-[#333] transition" data-id="element-496">
                  Annulla
                </button>
                <button type="button" onClick={handleSubmit} disabled={!canSubmit} className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold transition ${canSubmit ? 'bg-[#D4FF3A] text-[#0A0A0A] hover:bg-[#c2ed28]' : 'bg-[#1F1F1F] text-[#6B6B6B] cursor-not-allowed'}`} data-id="element-497">
                  Invia richiesta
                </button>
              </div>
            </div>
          </>}
      </div>
    </div>;
}
function AnomalyModal({
  issue,
  fieldLabel,
  initialValue,
  shipmentId,
  onClose
}: {
  issue: string;
  fieldLabel: string;
  initialValue: string;
  shipmentId: string;
  onClose: () => void;
}) {
  const [value, setValue] = useState(initialValue);
  const [resolved, setResolved] = useState(false);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-498">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-499" />
      <div className="relative w-full max-w-lg bg-[#0A0A0A] border border-[#262626] rounded-xl overflow-hidden" data-id="element-500">
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-[#262626]" data-id="element-501">
          <div className="min-w-0 flex items-center gap-2.5" data-id="element-502">
            <div className="h-8 w-8 rounded-lg bg-[#EF4444]/10 border border-[#EF4444]/30 text-[#EF4444] flex items-center justify-center shrink-0" data-id="element-503">
              <AlertTriangle className="h-4 w-4" data-id="element-504" />
            </div>
            <div className="min-w-0" data-id="element-505">
              <h3 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-506">
                Risolvi anomalia
              </h3>
              <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-507">
                Spedizione{' '}
                <span className="font-mono text-[#FAFAFA]" data-id="element-508">{shipmentId}</span>
              </div>
            </div>
          </div>
          <button type="button" onClick={onClose} className="p-1 rounded text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#181818] transition" aria-label="Chiudi" data-id="element-509">
            <X className="h-4 w-4" data-id="element-510" />
          </button>
        </div>
        {resolved ? <div className="p-5 flex flex-col items-center text-center" data-id="element-511">
            <div className="h-12 w-12 rounded-full bg-[#D4FF3A]/10 border border-[#D4FF3A]/30 flex items-center justify-center mb-3" data-id="element-512">
              <Check className="h-6 w-6 text-[#D4FF3A]" strokeWidth={2.5} data-id="element-513" />
            </div>
            <div className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-514">
              Anomalia risolta
            </div>
            <p className="text-xs text-[#9A9A9A] mt-1 max-w-xs" data-id="element-515">
              Abbiamo aggiornato i dati di consegna. La spedizione riprenderà a
              breve.
            </p>
            <div className="mt-3 text-xs font-mono text-[#FAFAFA] bg-[#181818] border border-[#262626] rounded-md px-2.5 py-1.5" data-id="element-516">
              {value}
            </div>
            <button type="button" onClick={onClose} className="mt-5 px-4 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-517">
              Chiudi
            </button>
          </div> : <form onSubmit={e => {
        e.preventDefault();
        if (value.trim()) setResolved(true);
      }} className="p-5 space-y-4" data-id="element-518">
            <div data-id="element-519">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium mb-1.5" data-id="element-520">
                Dettagli
              </div>
              <p className="text-sm text-[#9A9A9A] leading-relaxed" data-id="element-521">{issue}</p>
            </div>
            <div className="space-y-2" data-id="element-522">
              <label className="block text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-523">
                {fieldLabel}
              </label>
              <input type="text" value={value} onChange={e => setValue(e.target.value)} className="w-full px-3 py-2.5 rounded-lg bg-[#181818] border border-[#262626] text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/30 focus:border-[#333] font-mono" placeholder="Inserisci il dato corretto" data-id="element-524" />
            </div>
            <div className="flex items-center justify-end gap-2 pt-1" data-id="element-525">
              <button type="button" onClick={onClose} className="px-3.5 py-2 rounded-lg bg-[#181818] border border-[#262626] text-[#FAFAFA] text-sm font-medium hover:border-[#333] transition" data-id="element-526">
                Annulla
              </button>
              <button type="submit" className="px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-527">
                Conferma e sblocca
              </button>
            </div>
          </form>}
      </div>
    </div>;
}
function InfoGridContent({
  order,
  Icon
}: {
  order: Order;
  Icon: any;
}) {
  const [tab, setTab] = useState<'contenuto' | 'dettagli'>('contenuto');
  const totalCapi = order.items.reduce((s, i) => s + i.quantity, 0);
  return <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-528">
      <div className="px-5 py-4 border-b border-[#262626] flex items-center justify-between gap-3 flex-wrap" data-id="element-529">
        <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-530">
          Dettagli spedizione e contenuto
        </h3>
        <span className="inline-flex items-center gap-1.5 px-1.5 py-0.5 rounded text-[11px] bg-[#0A0A0A] border border-[#262626] text-[#9A9A9A]" data-id="element-531">
          <Icon className="h-3 w-3" data-id="element-532" />
          {order.colloType}
        </span>
      </div>

      <div className="px-5 py-3 border-b border-[#262626]" data-id="element-533">
        <div className="inline-flex items-center gap-1 p-1 rounded-lg bg-[#0A0A0A] border border-[#1F1F1F]" data-id="element-534">
          <button type="button" onClick={() => setTab('contenuto')} className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${tab === 'contenuto' ? 'bg-[#1F1F1F] text-[#FAFAFA]' : 'text-[#9A9A9A] hover:text-[#FAFAFA]'}`} data-id="element-535">
            Contenuto
          </button>
          <button type="button" onClick={() => setTab('dettagli')} className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${tab === 'dettagli' ? 'bg-[#1F1F1F] text-[#FAFAFA]' : 'text-[#9A9A9A] hover:text-[#FAFAFA]'}`} data-id="element-536">
            Dettagli
          </button>
        </div>
      </div>

      {tab === 'contenuto' && <div data-id="element-537">
          <div className="bg-[#0F0F0F] border-b border-[#262626] flex items-center" data-id="element-538">
            <div className="flex-1 px-5 py-4 text-center" data-id="element-539">
              <div className="text-xl font-mono text-[#FAFAFA]" data-id="element-540">
                {totalCapi}
              </div>
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium mt-1" data-id="element-541">
                Capi totali
              </div>
            </div>
            <div className="flex-1 px-5 py-4 text-center border-l border-[#262626]" data-id="element-542">
              <div className="text-xl font-mono text-[#FAFAFA]" data-id="element-543">
                {order.colli}
              </div>
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium mt-1" data-id="element-544">
                Colli
              </div>
            </div>
            <div className="flex-1 px-5 py-4 text-center border-l border-[#262626]" data-id="element-545">
              <div className="text-xl font-mono text-[#FAFAFA]" data-id="element-546">
                {order.items.length}
              </div>
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium mt-1" data-id="element-547">
                SKU
              </div>
            </div>
          </div>
          <ul className="divide-y divide-[#262626]" data-id="element-548">
            {order.items.map((item, idx) => <li key={item.id} className="px-5 py-3.5 flex items-center justify-between gap-3" data-id="element-549">
                <div className="flex items-center gap-3 min-w-0" data-id="element-550">
                  <span className="text-xs font-mono text-[#6B6B6B] w-7 shrink-0" data-id="element-551">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <div className="min-w-0 flex items-center gap-2 flex-wrap" data-id="element-552">
                    <div className="text-sm text-[#FAFAFA] truncate" data-id="element-553">
                      {item.name}
                    </div>
                    <span className="inline-flex px-1.5 py-0.5 rounded bg-[#0A0A0A] border border-[#262626] text-[10px] font-mono text-[#9A9A9A]" data-id="element-554">
                      {item.sku}
                    </span>
                  </div>
                </div>
                <span className="text-sm font-mono text-[#FAFAFA] shrink-0" data-id="element-555">
                  ×{item.quantity}
                </span>
              </li>)}
          </ul>
        </div>}

      {tab === 'dettagli' && <div data-id="element-556">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-4 p-5" data-id="element-557">
            <div data-id="element-558">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-559">
                Riferimento
              </div>
              <div className="text-sm font-mono text-[#FAFAFA] mt-1" data-id="element-560">
                {order.id}
              </div>
            </div>
            <div data-id="element-561">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-562">
                Tracking
              </div>
              <div className="text-sm font-mono text-[#FAFAFA] mt-1 truncate" data-id="element-563">
                {order.trackingId}
              </div>
            </div>
            <div data-id="element-564">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-565">
                Vettore
              </div>
              <div className="text-sm text-[#FAFAFA] mt-1" data-id="element-566">{order.carrier}</div>
            </div>
            <div data-id="element-567">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-568">
                Colli
              </div>
              <div className="text-sm font-mono text-[#FAFAFA] mt-1" data-id="element-569">
                {order.colli}
              </div>
            </div>
            <div data-id="element-570">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-571">
                Capi
              </div>
              <div className="text-sm font-mono text-[#FAFAFA] mt-1" data-id="element-572">
                {totalCapi}
              </div>
            </div>
            <div data-id="element-573">
              <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-574">
                SKU
              </div>
              <div className="text-sm font-mono text-[#FAFAFA] mt-1" data-id="element-575">
                {order.items.length}
              </div>
            </div>
          </div>
          <div className="border-t border-[#262626] px-5 py-3 text-sm text-[#9A9A9A] flex items-start gap-2" data-id="element-576">
            <Icon className="h-4 w-4 shrink-0 mt-0.5 text-[#6B6B6B]" data-id="element-577" />
            <span className="leading-relaxed" data-id="element-578">
              <span className="text-[#6B6B6B] font-medium" data-id="element-579">Riepilogo: </span>
              {order.contentSummary}
            </span>
          </div>
        </div>}
    </div>;
}